import { Box, BoxProps, Button, ColorOptions, convertHexToRGBA, Icon, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { useCallback, useEffect, useState } from 'react'
import { FlatList, LayoutAnimation, Platform, UIManager, ViewStyle } from 'react-native'
import EmptyView from '../../../../comps/EmptyView'
import { SvgImage } from '../../../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../../../data/store'
import { Routes } from '../../../../nav/routes'
import { Colors, groupBy, isOsMobile, logEvent } from '../../../../util/util'
import { getFullName, getProfileLabel, sortByDate } from '../Helper'

const RenderItem = ({ item, handleOnpress, handleCollapse }: any) => {
  const { title, data, isExpantedBox }: any = item
  const label = title.slice(0, 1) + title.toLowerCase()?.slice(1)
  const labelTitle = `${label} Users (${data?.length})`
  return (
    <Box ph={25}>
      <Box
        flexDirection={'row'}
        underlayColor={'TRANSPARENT'}
        testID={'collapse-users'}
        onPress={() => handleCollapse({ id: item?.id, item })}>
        <Text fontFamily={'JioType-Bold'} fontSize={14}>
          {labelTitle}
        </Text>
        <Spacer size={10} direction="horizontal" />
        <Icon size={18} color="BLACK" id={isExpantedBox ? 'ARROW_UP' : 'ARROW_DOWN'} />
      </Box>

      <Spacer size={10} direction="vertical" />
      {isExpantedBox && (
        <FlatList
          // contentContainerStyle={styles.subListContainer}
          data={data}
          renderItem={({ item }: any) => renderSubItem({ item, handleOnpress })}
        />
      )}
      <Spacer size={10} direction="vertical" />
    </Box>
  )
}

const renderSubItem = ({ item, handleOnpress }: any) => {
  const { status } = item
  // console.log('sub', item)
  const nameNa = item?.user?.name?.firstName === '' && item?.user?.name?.lastName === ''
  const fullName: any = getFullName(item)
  const profileLabel: any = getProfileLabel(item)
  return (
    <Box
      underlayColor={'TRANSPARENT'}
      onPress={() => handleOnpress(item)}
      testID="select-user"
      flexDirection="row"
      marginVertical={15}
      justifyContent={'space-between'}
      align="center">
      <Box flexDirection={'row'} align="center">
        <Box
          width={45}
          height={45}
          borderRadius={45}
          bg={convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions}
          align="center"
          justify="center">
          {!profileLabel ? (
            <Box {...({ transform: [{ scale: 0.8 }] } as BoxProps)}>
              <SvgImage imageName="ProfileIcon" color={Colors.SECONDARY} />
            </Box>
          ) : (
            <Text fontFamily={'JioType-Bold'} fontSize={14} color={Colors.SECONDARY as ColorOptions}>
              {profileLabel ? profileLabel : 'NA'}
            </Text>
          )}
        </Box>
        <Spacer size={10} direction="horizontal" />
        <Box>
          <Text fontFamily={'JioType-Bold'} lineHeight={21} fontSize={14} color={Colors.BLACK_14 as ColorOptions}>
            {fullName ? fullName : 'NA'}
          </Text>
          <Box flexDirection={'row'} align="center">
            <Text color="PRIMARY_GREY" lineHeight={16} fontFamily={'JioType-Medium'} fontSize={12}>
              +{item?.user?.mobile?.countryCode}
              {item?.user?.mobile?.mobileNumber}{' '}
            </Text>
            <ModBox show={item?.department} flexDirection={'row'} align="center">
              <Spacer size={4} direction="horizontal" />
              <Box width={5} height={5} borderRadius={5} backgroundColor={'#B5B5B5' as ColorOptions} />
              <Spacer size={6} direction="horizontal" />
              <Text lineHeight={16} color="PRIMARY_GREY" fontFamily={'JioType-Medium'} fontSize={12}>
                {item?.department}
              </Text>
            </ModBox>
          </Box>
        </Box>
      </Box>
      <Box
        justifyContent={'flex-end'}
        flexDirection="row"
        pv={3}
        ph={6}
        borderRadius={4}
        {...styles?.textColorStatus(status)}>
        <Text fontFamily={'JioType-Bold'} color={'WHITE'} fontSize={12}>
          {status === 'TERMINATED' ? 'DELETED' : status}
        </Text>
      </Box>
    </Box>
  )
}

if (Platform.OS === 'android') {
  UIManager.setLayoutAnimationEnabledExperimental(true)
}

const ManageUsersNew = () => {
  const navigation = useNavigation()
  const isFocused = useIsFocused()

  const { mobileNumber, getUsers, getUsersListApi, mid, masterDataList, getMasterPermissionCheckboxData } = useStores(
    (store) => ({
      getUsers: store.userManagement.getUsers,
      getUsersListApi: store.userManagement.getUsersListApi,
      mid: store.user.selectedMid,
      masterDataList: store.userManagement.masterPermissionList,
      getMasterPermissionCheckboxData: store.userManagement.getMasterPermissionCheckboxData,
      mobileNumber: store.settings.metaData.selectedMobileNumber,
    }),
  )
  const [isLoading, setIsLoading] = useState(true)
  const [users, setUsers] = useState([])
  const [fetchUserList, fetchUserListHandler = { data: [], state: 'pending' }] = useLazyApiData(getUsersListApi)

  const errorState = fetchUserListHandler?.data?.messsage ?? false
  const emptyMessage =
    fetchUserListHandler.state !== 'fulfilled' && fetchUserListHandler?.data?.length === 0 ? 'No users found...' : ''

  const [sectionData, setSectionData] = useState([])

  useEffect(() => {
    isFocused &&
      fetchUserList({
        entityId: mid,
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused])
  useEffect(() => {
    if (masterDataList === null) {
      getMasterPermissionCheckboxData()
    }
  }, [getMasterPermissionCheckboxData, masterDataList])

  const getUserList = useCallback(() => {
    let userList: any = []
    let dataMapped = []

    const users2 = getUsers(true)
    setUsers(users2)

    if (mid && users2?.length > 0) {
      let usersCopy = JSON.parse(JSON.stringify(users2))
      // TODO: disable own number permissions changes here
      // if (mobileNumber) {
      //   usersCopy = usersCopy.filter((item) => {
      //     return item?.user?.mobile?.mobileNumber.indexOf(mobileNumber) < 0
      //   })
      // }
      userList = groupBy(usersCopy, 'status')

      delete userList?.[undefined]
      dataMapped = []
      Object.keys(userList)?.map((key, index) => {
        let dataSorted: any = sortByDate(userList[key])
        dataMapped.push({ title: key, data: dataSorted, isExpantedBox: true, id: index })
      })
      let priorities = ['ACTIVE', 'BLOCKED', 'TERMINATED']
      dataMapped.sort((a, b) => priorities.indexOf(a.title) - priorities.indexOf(b.title))
      setSectionData(dataMapped)
      setIsLoading(false)
    } else {
      return setSectionData([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mid, mobileNumber])

  useEffect(() => {
    if (fetchUserListHandler.state === 'fulfilled') {
      getUserList()
    }
  }, [fetchUserListHandler.state, getUserList])

  // console.log('sectionData grouped', sectionData)

  const addNewUser = () => {
    logEvent('btn_press', 'open_add new user')
    navigation.navigate(Routes.USER_MANAGEMENT.ADD_USER_MOBILE)
  }

  const userNavigation = (data: any) => {
    logEvent('item_press', 'users')
    const user = users?.find((item: any) => item.jfsUserId === data.jfsUserId)
    //console.log('data nav', user[0].jfsUserId)
    navigation.navigate(
      Routes.USER_MANAGEMENT.USER_DETAILS_MOBILE as never,
      { user: JSON.parse(JSON.stringify(user)) } as never,
    )
  }

  const handleCollapse = ({ id }: any) => {
    // console.log('item should collapse or expand', id)
    const sectionDataSelected = sectionData?.map((element: any) => {
      if (element.id === id) {
        return { ...element, isExpantedBox: !element.isExpantedBox }
      } else {
        return { ...element }
      }
    })
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut)
    setSectionData(sectionDataSelected)
  }

  return (
    <Box flex={1} backgroundColor="SECONDARY">
      <ModBox {...styles.listWrapper} overflowY="auto" justifyContent="space-between">
        <ModBox show={isLoading} justifyContent={'center'} flex={1} bg={'WHITE'}>
          <EmptyView
            testID="empty_view"
            onRetry={() => console.log('Retry')}
            isLoading={isLoading}
            error={errorState}
            emptyMessage={emptyMessage}
            loadingMessage="Fetching Users..."
            hide={!isLoading && !errorState && !emptyMessage}
          />
        </ModBox>
        <ModBox flex={1} show={users?.length > 0 && !isLoading && !errorState}>
          <FlatList
            data={sectionData}
            renderItem={({ item, index }) => (
              <RenderItem handleOnpress={userNavigation} handleCollapse={handleCollapse} item={item} index={index} />
            )}
          />
          <Spacer size={50} direction="vertical" />
        </ModBox>
        <ModBox
          show={!isLoading}
          {...styles.buttonProp(isOsMobile())}
          borderTopWidth={1}
          borderTopColor={convertHexToRGBA('#000', 16) as ColorOptions}>
          <Button isFull isRound onPress={addNewUser} testID="add-user" height={48}>
            <Text color="WHITE" fontSize={16} fontFamily="JioType-Medium">
              Add new user
            </Text>
          </Button>
        </ModBox>
      </ModBox>
    </Box>
  )
}

const styles = {
  listWrapper: {
    backgroundColor: 'WHITE',
    pv: 25,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    width: '100%',
    marginTop: 60,
    flex: 1,
    zIndex: 4,
    overflow: 'auto',
  } as BoxProps,
  listContainer: {
    flex: 1,
    flexGrow: 1,
  } as ViewStyle,
  subListContainer: {
    alignSelf: 'flex-start',
    flex: 1,
  } as ViewStyle,
  textColorStatus: (status: any) =>
    ({
      bg:
        status === 'ACTIVE'
          ? ('#00B259' as ColorOptions)
          : status === 'BLOCKED'
          ? ('#FA7D19' as ColorOptions)
          : status === 'DELETED' || status === 'TERMINATED'
          ? ('#E30513' as ColorOptions)
          : 'TEXT_PENDING',
    } as BoxProps),
  buttonProp: (isOsMobile: boolean) =>
    ({
      position: isOsMobile ? 'absolute' : 'sticky',
      backgroundColor: 'WHITE' as ColorOptions,
      width: '100%',
      justifyContent: 'center',
      ph: 25,
      pv: 15,
      left: 0,
      bottom: 0,
      borderRadius: 8,
    } as BoxProps),
}

export default ManageUsersNew
